module.exports = __webpack_public_path__ + "img/2025-06-11c_2.888e25eb.jpg";